import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import "./App.css";

import Header from "./components/Header";
import Footer from "./components/Footer";
import SmoothScroll from "./components/SmoothScroll";
import CursorFollower from "./components/CursorFollower";
import ScrollToTop from "./components/ScrollToTop";

import Home from "./pages/Home";
import About from "./pages/About";
import Servizi from "./pages/Servizi";
import ServizioDetail from "./pages/ServizioDetail";
import ServizioImpactStrategy from "./pages/ServizioImpactStrategy";
import ServizioSponsorship from "./pages/ServizioSponsorship";
import ServizioContentIP from "./pages/ServizioContentIP";
import ServizioPitchPartner from "./pages/ServizioPitchPartner";
import ServizioResearchInsight from "./pages/ServizioResearchInsight";
import ServizioPerformanceMarketing from "./pages/ServizioPerformanceMarketing";
import Works from "./pages/Works";
import WorkScuolaAttiva from "./pages/WorkScuolaAttiva";
import WorkAcMilanConnect from "./pages/WorkAcMilanConnect";
import WorkKappaCoop from "./pages/WorkKappaCoop";
import WorkVeroVolley from "./pages/WorkVeroVolley";
import WorkVolleyballWorld from "./pages/WorkVolleyballWorld";
import WorkNoleggiareHellas from "./pages/WorkNoleggiareHellas";
import WorkRealeMutuaEssereLibero from "./pages/WorkRealeMutuaEssereLibero";
import WorkMizunoReachBeyond from "./pages/WorkMizunoReachBeyond";
import WorkCredemExtraOrdinary from "./pages/WorkCredemExtraOrdinary";
import WorkRealeMutuaYourNextLevel from "./pages/WorkRealeMutuaYourNextLevel";
import WorkProtek from "./pages/WorkProtek";
import WorkMizunoValentinaZago from "./pages/WorkMizunoValentinaZago";
import WorkEmpower from "./pages/WorkEmpower";
import WorkLvfTv from "./pages/WorkLvfTv";
import WorkNikeJd from "./pages/WorkNikeJd";
import WorkPradaAmericasCup from "./pages/WorkPradaAmericasCup";
import WorkProblemiDiVolley from "./pages/WorkProblemiDiVolley";
import WorkRealeMutuaTogetherForUkraine from "./pages/WorkRealeMutuaTogetherForUkraine";
import WorkSportlinx360 from "./pages/WorkSportlinx360";
import JoinTeam from "./pages/JoinTeam";
import News from "./pages/News";
import NewsArticle from "./pages/NewsArticle";
import Newsletter from "./pages/Newsletter";
import Contatti from "./pages/Contatti";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import CookiePolicy from "./pages/CookiePolicy";
import NotFound from "./pages/NotFound";
import CookieConsentBanner from "./components/CookieConsentBanner";
import TrackingScripts from "./components/TrackingScripts";

// ============================================================================
// REDIRECTS LEGACY (equivalente client-side della redirects() di next.config.js)
// Le destinazioni sono allineate alle route reali presenti in <Routes> sotto.
// ============================================================================
const LEGACY_REDIRECTS = [
  // NAVIGATION / PAGINE PRINCIPALI
  { from: "/teletext", to: "/news" },
  { from: "/teletext/*", to: "/news" },
  { from: "/careers", to: "/join-the-team" },
  { from: "/careers/*", to: "/join-the-team" },
  { from: "/team-onsports", to: "/join-the-team" },
  { from: "/team-onsports/*", to: "/join-the-team" },

  // CASE STUDY legacy /project/[slug] → /works/[slug] (slug reali)
  { from: "/project/ac-milan-connect", to: "/works/ac-milan-connect" },
  { from: "/project/ac-milan-connect/*", to: "/works/ac-milan-connect" },
  { from: "/project/kappa-x-coop", to: "/works/kappa-x-coop" },
  { from: "/project/kappa-x-coop/*", to: "/works/kappa-x-coop" },
  { from: "/project/noleggiare-x-hellas", to: "/works/noleggiare-hellas" },
  { from: "/project/noleggiare-x-hellas/*", to: "/works/noleggiare-hellas" },
  { from: "/project/reale-mutua-your-next-level-chieri-76", to: "/works/reale-mutua-your-next-level" },
  { from: "/project/reale-mutua-your-next-level-chieri-76/*", to: "/works/reale-mutua-your-next-level" },
  { from: "/project/reale-mutua", to: "/works/reale-mutua-essere-libero" },
  { from: "/project/reale-mutua/*", to: "/works/reale-mutua-essere-libero" },
  { from: "/project/lega-pallavolo-serie-a-femminile", to: "/works/lvf-tv" },
  { from: "/project/lega-pallavolo-serie-a-femminile/*", to: "/works/lvf-tv" },

  // CASE STUDY legacy /[slug] piatto → /works/[slug] (slug reali)
  { from: "/mizuno-reach-beyond-world-champions", to: "/works/mizuno-reach-beyond" },
  { from: "/mizuno-reach-beyond-world-champions/*", to: "/works/mizuno-reach-beyond" },
  { from: "/onsports-x-mizuno-reach-beyond", to: "/works/mizuno-valentina-zago" },
  { from: "/onsports-x-mizuno-reach-beyond/*", to: "/works/mizuno-valentina-zago" },
  { from: "/151-onsports-x-credem-extra-ordinary", to: "/works/credem-extra-ordinary" },
  { from: "/151-onsports-x-credem-extra-ordinary/*", to: "/works/credem-extra-ordinary" },
  { from: "/empower", to: "/works/empower" },
  { from: "/empower/*", to: "/works/empower" },
  { from: "/protek", to: "/works/protek" },
  { from: "/protek/*", to: "/works/protek" },

  // CASE STUDY ORFANI → catch-all /works
  { from: "/project/nike-jd", to: "/works/nike-jd" },
  { from: "/project/nike-jd/*", to: "/works/nike-jd" },
  { from: "/project/ac36", to: "/works/prada-americas-cup" },
  { from: "/project/ac36/*", to: "/works/prada-americas-cup" },
  { from: "/project/wyscout", to: "/works" },
  { from: "/project/wyscout/*", to: "/works" },
  { from: "/project/problemi-di-volley", to: "/works/problemi-di-volley" },
  { from: "/project/problemi-di-volley/*", to: "/works/problemi-di-volley" },
  { from: "/204-onsports-feat-la-giornata-tipo-x-reale-mutua", to: "/works/reale-mutua-together-for-ukraine" },
  { from: "/204-onsports-feat-la-giornata-tipo-x-reale-mutua/*", to: "/works/reale-mutua-together-for-ukraine" },

  // CATCH-ALL /project/* (dopo le regole specifiche sopra)
  { from: "/project", to: "/works" },
  { from: "/project/*", to: "/works" },

  // LEGAL — /privacy-policy-2 → /privacy-policy
  { from: "/privacy-policy-2", to: "/privacy-policy" },
  { from: "/privacy-policy-2/*", to: "/privacy-policy" },

  // WORDPRESS LEGACY
  { from: "/wp-admin/*", to: "/" },
  { from: "/wp-content/*", to: "/" },
];

function App() {
  return (
    <div className="App bg-galactico text-dodgers">
      <BrowserRouter>
        <ScrollToTop />
        <SmoothScroll />
        <CursorFollower />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/servizi" element={<Servizi />} />
            <Route path="/servizi/impact-strategy-advisory" element={<ServizioImpactStrategy />} />
            <Route path="/servizi/sponsorship-impact-programs" element={<ServizioSponsorship />} />
            <Route path="/servizi/content-ip-studio" element={<ServizioContentIP />} />
            <Route path="/servizi/pitchpartner" element={<ServizioPitchPartner />} />
            <Route path="/servizi/research-insight" element={<ServizioResearchInsight />} />
            <Route path="/servizi/performance-marketing-growth" element={<ServizioPerformanceMarketing />} />
            <Route path="/servizi/:slug" element={<ServizioDetail />} />
            <Route path="/works" element={<Works />} />
            <Route path="/works/scuola-attiva" element={<WorkScuolaAttiva />} />
            <Route path="/works/ac-milan-connect" element={<WorkAcMilanConnect />} />
            <Route path="/works/kappa-x-coop" element={<WorkKappaCoop />} />
            <Route path="/works/vero-volley" element={<WorkVeroVolley />} />
            <Route path="/works/volleyball-world-italia" element={<WorkVolleyballWorld />} />
            <Route path="/works/noleggiare-hellas" element={<WorkNoleggiareHellas />} />
            <Route path="/works/reale-mutua-essere-libero" element={<WorkRealeMutuaEssereLibero />} />
            <Route path="/works/mizuno-reach-beyond" element={<WorkMizunoReachBeyond />} />
            <Route path="/works/credem-extra-ordinary" element={<WorkCredemExtraOrdinary />} />
            <Route path="/works/reale-mutua-your-next-level" element={<WorkRealeMutuaYourNextLevel />} />
            <Route path="/works/protek" element={<WorkProtek />} />
            <Route path="/works/mizuno-valentina-zago" element={<WorkMizunoValentinaZago />} />
            <Route path="/works/empower" element={<WorkEmpower />} />
            <Route path="/works/lvf-tv" element={<WorkLvfTv />} />
            <Route path="/works/nike-jd" element={<WorkNikeJd />} />
            <Route path="/works/prada-americas-cup" element={<WorkPradaAmericasCup />} />
            <Route path="/works/problemi-di-volley" element={<WorkProblemiDiVolley />} />
            <Route path="/works/reale-mutua-together-for-ukraine" element={<WorkRealeMutuaTogetherForUkraine />} />
            <Route path="/works/sportlinx360" element={<WorkSportlinx360 />} />
            <Route path="/join-the-team" element={<JoinTeam />} />
            <Route path="/news" element={<News />} />
            <Route path="/news/:slug" element={<NewsArticle />} />
            <Route path="/newsletter" element={<Newsletter />} />
            <Route path="/contatti" element={<Contatti />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/cookie-policy" element={<CookiePolicy />} />
            {/* Legacy redirects (client-side equivalents of next.config redirects) */}
            {LEGACY_REDIRECTS.map(({ from, to }) => (
              <Route
                key={from}
                path={from}
                element={<Navigate to={to} replace />}
              />
            ))}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
        <TrackingScripts />
        <CookieConsentBanner />
        <Toaster
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#003143",
              color: "#FFFFFF",
              border: "1.5px solid #E0DC1B",
              borderRadius: 0,
              fontFamily: "'Hanken Grotesk', sans-serif",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
